var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 114,
    viewBox: "0 0 122 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1538 85.5V104.88H93.8461V85.5H28.1538ZM28.1538 9.12V57H93.8461V28.5H82.1154C80.1603 28.5 78.4984 27.8073 77.1298 26.4219C75.7612 25.0365 75.0769 23.3542 75.0769 21.375V9.12H28.1538ZM111.222 65.0898C112.151 64.1497 112.615 63.0365 112.615 61.75C112.615 60.4635 112.151 59.3503 111.222 58.4102C110.294 57.4701 109.194 57 107.923 57C106.652 57 105.552 57.4701 104.624 58.4102C103.695 59.3503 103.231 60.4635 103.231 61.75C103.231 63.0365 103.695 64.1497 104.624 65.0898C105.552 66.0299 106.652 66.5 107.923 66.5C109.194 66.5 110.294 66.0299 111.222 65.0898ZM117.858 51.6934C120.619 54.4889 122 57.8411 122 61.75V92.625C122 93.2682 121.768 93.8249 121.303 94.2949C120.839 94.765 120.289 95 119.654 95H103.231V106.875C103.231 108.854 102.546 110.536 101.178 111.922C99.8093 113.307 98.1474 114 96.1923 114H25.8077C23.8526 114 22.1907 113.307 20.8221 111.922C19.4535 110.536 18.7692 108.854 18.7692 106.875V95H2.34615C1.71074 95 1.16086 94.765 0.696514 94.2949C0.232172 93.8249 0 93.2682 0 92.625V61.75C0 57.8411 1.38081 54.4889 4.14243 51.6934C6.90405 48.8978 10.2155 47.5 14.0769 47.5H18.7692V7.125C18.7692 5.14583 19.4535 3.46354 20.8221 2.07812C22.1907 0.692708 23.8526 0 25.8077 0H75.0769C77.0321 0 79.1827 0.494792 81.5288 1.48438C83.875 2.47396 85.7324 3.66146 87.101 5.04688L98.2452 16.3281C99.6138 17.7135 100.787 19.5938 101.764 21.9688C102.742 24.3438 103.231 26.5208 103.231 28.5V47.5H107.923C111.784 47.5 115.096 48.8978 117.858 51.6934Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.05f6409ff59a56d13a961b8e1d6f20d9.svg";
export { ForwardRef as ReactComponent };